<template>
  <div style="padding: 10px">
    <b-breadcrumb>
      <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
      <b-breadcrumb-item>
        <router-link tag="a" to="/audit-list">Audit-List</router-link>
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ formName }}</b-breadcrumb-item>
    </b-breadcrumb>

    <div v-if="isForm">
      <center>
        <h5 style="font-weight: 600; text-decoration: underline">
          Input Jumlah Artikel
        </h5>
      </center>
      <div style="margin-left: 10px; margin-bottom: 20px">
        <span style="font-weight: 500">Store : {{ items[0].store }}</span>
      </div>

      <b-row
        class="mb-2"
        style="align-items: center; justify-content: space-between"
      >
        <b-col cols="9">
          <b-input-group>
            <b-form-input
              v-model="search"
              @input="doSearch()"
              placeholder="🔍 Search"
            ></b-form-input>
          </b-input-group>
        </b-col>

        <b-col cols="3" class="text-right">
          <strong>{{ shownCount }} / {{ filteredItems.length }}</strong>
        </b-col>
      </b-row>

      <!-- List -->
      <b-list-group flush>
        <b-list-group-item style="border: none">
          <!-- ================= DESKTOP VIEW ================= -->
          <div v-if="!isMobile">
            <b-row
              style="
                font-size: 14px;
                font-weight: 600;
                border-bottom: 2px solid #ccc;
                padding-bottom: 8px;
                margin-bottom: 10px;
              "
            >
              <b-col cols="1">No</b-col>
              <b-col cols="2">Category</b-col>
              <b-col cols="2">Article</b-col>
              <b-col cols="1"><center>Stock Odoo 20 Nov</center></b-col>
              <b-col cols="1"><center>Stock Fisik STO 20 Nov</center></b-col>
              <b-col cols="1"
                ><center>Stock Odoo {{ currentDate }}</center></b-col
              >
              <b-col cols="1"><center>Stock Hasil Konsolidasi</center></b-col>
              <b-col cols="1"><center>Stock Hasil Validasi</center></b-col>
              <b-col cols="2"><center>Remark</center></b-col>
            </b-row>

            <b-row
              v-for="(item, idx) in paginatedItems"
              :key="idx"
              style="
                font-size: 13px;
                font-weight: 500;
                padding: 8px 0;
                border-bottom: 1px solid #eee;
              "
            >
              <b-col cols="1">{{ idx + 1 }}</b-col>
              <b-col cols="2">{{ item.category }}</b-col>
              <b-col cols="2">{{ item.article }}</b-col>
              <b-col cols="1"
                ><center>{{ item.qty_past }}</center></b-col
              >
              <b-col cols="1"
                ><center>{{ item.actual_past }}</center></b-col
              >
              <b-col cols="1"
                ><center>{{ item.qty }}</center></b-col
              >
              <b-col cols="1"
                ><center>{{ item.qty_plan }}</center></b-col
              >

              <b-col cols="1">
                <center>
                  <input
                    v-model="item.actual_qty"
                    @blur="changeQty(item)"
                    type="number"
                    style="
                      width: 80px;
                      text-align: center;
                      border: 1px solid #666;
                    "
                  />
                  <span v-if="item.qty_plan == item.actual_qty">✔️</span>
                </center>
              </b-col>

              <b-col cols="2">
                <textarea
                  v-model="item.remark"
                  @blur="changeQty(item)"
                  style="
                    width: 100%;
                    height: 30px;
                    border: 1px solid #666;
                    font-size: 12px;
                  "
                ></textarea>
              </b-col>
            </b-row>
          </div>

          <!-- ================= MOBILE VIEW ================= -->
          <div v-else>
            <div
              v-for="(item, idx) in paginatedItems"
              :key="idx"
              style="
                padding: 12px;
                margin-bottom: 12px;
                border: 1px solid #ddd;
                border-radius: 8px;
                background: #fafafa;
                font-size: 13px;
              "
            >
              <div><b>No:</b> {{ idx + 1 }}</div>
              <div><b>Category:</b> {{ item.category }}</div>
              <div><b>Article:</b> {{ item.article }}</div>

              <div><b>Stock Odoo 20 Nov:</b> {{ item.qty_past }}</div>
              <div><b>Stock Fisik STO 20 Nov:</b> {{ item.actual_past }}</div>
              <div><b>Stock Odoo {{ currentDate }}:</b> {{ item.qty }}</div>
              <div><b>Konsolidasi:</b> {{ item.qty_plan }}</div>

              <div style="margin-top: 6px">
                <b>Stock Validasi:</b><br />
                <input
                  v-model="item.actual_qty"
                  @blur="changeQty(item)"
                  type="number"
                  style="
                    width: 100%;
                    text-align: center;
                    border: 1px solid #666;
                    padding: 4px;
                    margin-top: 4px;
                  "
                />
                <span v-if="item.qty_plan == item.actual_qty">✔️</span>
              </div>

              <div style="margin-top: 6px">
                <b>Remark:</b>
                <textarea
                  v-model="item.remark"
                  @blur="changeQty(item)"
                  style="
                    width: 100%;
                    height: 40px;
                    border: 1px solid #666;
                    margin-top: 4px;
                  "
                ></textarea>
              </div>
            </div>
          </div>
        </b-list-group-item>
        <!-- Pagination -->
        <b-row class="mt-3" style="justify-content: center">
          <b-button size="sm" @click="prevPage" :disabled="currentPage === 1">
            Back
          </b-button>
          <b-button
            size="md"
            class="ml-3"
            style="color: white"
            @click="nextPage"
            v-if="currentPage !== totalPages"
          >
            Next
          </b-button>
          <b-button
            size="md"
            variant="success"
            style="color: white"
            class="ml-3"
            @click="submitPage"
            v-if="
              currentPage === totalPages && dataForm.status_audit !== 'Done'
            "
          >
            Submit
          </b-button>
        </b-row>
      </b-list-group>
      <Loader
        v-if="isLoadingData"
        fullPage
        useOverlay
        loader="spinner"
      ></Loader>
    </div>

    <div v-if="isReport">
      <center>
        <h5 style="font-weight: 600; text-decoration: underline">Review</h5>
      </center>
      <div style="margin-left: 15px; margin-bottom: 10px">
        <span style="font-weight: 500">Store : {{ items[0].store }}</span>
        <br />
        <span style="font-weight: 500">Pic : {{ spgData.name }}</span>
      </div>

      <b-row align-h="start">
        <b-col sm="12">
          <!-- HEADER -->
          <b-row style="margin: 0px; font-size: 14px; font-weight: 600">
            <div style="display: contents; font-weight: 600">
              <span style="width: 5%; padding-bottom: 10px">
                <center>No</center>
              </span>
              <span style="width: 15%; padding-bottom: 10px">
                <center>Category</center>
              </span>
              <span style="width: 15%; padding-bottom: 10px">
                <center>Article</center>
              </span>
              <span style="width: 20%; padding-bottom: 10px">
                <center>Qty konsolidasi</center>
              </span>
              <span style="width: 15%; padding-bottom: 10px">
                <center>Qty vaidasi</center>
              </span>
              <span style="width: 30%; padding-bottom: 10px">
                <center>Remark</center>
              </span>
            </div>
          </b-row>

          <b-row
            v-for="(row, idx) in items"
            :key="idx"
            style="margin: 0px; font-size: 13px; font-weight: 500"
          >
            <div style="display: contents">
              <!-- Number -->
              <span style="width: 5%; padding-bottom: 10px">
                <center>
                  {{ idx + 1 }}
                </center>
              </span>

              <!-- Category -->
              <span style="width: 15%; padding-bottom: 10px">
                <center>{{ row.category }}</center>
              </span>

              <!-- Article -->
              <span style="width: 15%; padding-bottom: 10px">
                <center>{{ row.article }}</center>
              </span>

              <!-- Plan -->
              <span style="width: 20%; padding-bottom: 10px">
                <center>{{ row.qty_plan }}</center>
              </span>

              <!-- totalQty -->
              <span style="width: 15%; padding-bottom: 10px">
                <center>{{ row.actual_qty }}</center>
              </span>
              <!-- remark -->
              <span style="width: 30%; padding-bottom: 10px">
                <center>{{ row.remark }}</center>
              </span>
            </div>
          </b-row>
        </b-col>
      </b-row>
      <div>
        <button
          @click="goBack"
          style="
            position: relative;
            top: 10px;
            left: 10px;
            font-size: 12px;
            padding: 3px 10px;
            background-color: #a7d194;
            border: 1px solid #7fa86b;
            border-radius: 4px;
          "
        >
          Back
        </button>
      </div>

      <div
        style="
          border: 2px solid #000;
          padding: 15px;
          margin-top: 20px;
          position: relative;
        "
      >
        <!-- TITLE -->
        <h6
          style="
            text-align: center;
            font-weight: bold;
            text-decoration: underline;
            margin-bottom: 20px;
          "
        >
          PERNYATAAN HASIL Validasi
        </h6>

        <!-- STATEMENT LIST -->
        <ul style="font-size: 14px; line-height: 1.6; padding-left: 20px">
          <li>
            <input type="checkbox" v-model="check1" />
            Seluruh data validasi yang saya input adalah benar sesuai dengan
            jumlah fisik inventory yang divalidasi.
          </li>

          <li style="margin-top: 10px">
            <input type="checkbox" v-model="check2" />
            Informasi yang saya laporkan dapat dipertanggungjawabkan dengan
            jujur dan penuh integritas.
          </li>
        </ul>

        <!-- SUBMIT BUTTON -->
        <div style="text-align: center; margin-top: 25px">
          <button
            @click="confirmSubmit"
            :disabled="!check1 || !check2"
            style="
              width: 80%;
              padding: 12px;
              background-color: #dcdcdc;
              border: 1px solid #999;
              font-size: 16px;
              font-weight: bold;
              border-radius: 6px;
              opacity: 1;
            "
          >
            Submit dan Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loader from "@/components/Loader/Loader";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_CGC } from "../../../../api/api-paths";
export default {
  components: {
    Loader,
  },
  data() {
    return {
      isLoadingData: false,
      formName: "Audit",
      isMobile: false,
      currentDate: this.formatDate(new Date()),
      isLoading: false,
      form: {
        role: null,
        start_limit: null,
        end_limit: null,
        user_nik: null,
        username: null,
      },
      currentPage: 1,
      perPage: 10,
      search: "",

      items: [],
      isReport: false,
      isForm: true,
      spgData: null,
      dataForm: null,
      check2: false,
      check1: false,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),

    filteredItems() {
      if (!this.search) return this.items;
      const term = this.search.toLowerCase();

      return this.items.filter(
        (item) =>
          item.article.toLowerCase().includes(term) ||
          item.category.toLowerCase().includes(term)
      );
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.perPage);
    },

    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredItems.slice(start, start + this.perPage);
    },

    // Counter like "5 / 20"
    shownCount() {
      const count = this.currentPage * this.perPage;
      return count > this.filteredItems.length
        ? this.filteredItems.length
        : count;
    },
  },
  methods: {
    ...mapActions("session", ["showNotification"]),

    formatDate(date) {
      const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const day = date.getDate();
      const month = months[date.getMonth()];
      return `${day} ${month}`;
    },

    setData() {
      let data = this.$route.params.data;
      console.log("data", data);
      console.log("data", data);
      this.dataForm = data;
      console.log(this.dataForm);
      this.spgData = JSON.parse(localStorage.getItem("spg_audit"));
      console.log(this.spgData);
      if (this.spgData && data) {
        this.LoadData();
      } else {
        this.$router.push({ name: "CGCAudit" });
      }
    },

    LoadData() {
      this.isLoadingData = true;
      fnPOST(APIPATH_CGC.getListDetailAudit, {
        id: this.dataForm.id,
      })
        .then((response) => {
          this.isLoadingData = false;
          this.items = response.data.payload;
          this.updateData();
        })
        .catch((error) => {
          this.isLoadingData = false;
          this.showNotification({
            message: error,
            type: "error",
          });
        });
    },

    changeQty(item) {
      console.log(item);
      if (item.actual_qty) {
        this.updateData();
      }
    },

    updateData() {
      if (this.dataForm.status_audit !== "Done") {
        fnPOST(APIPATH_CGC.updateListDetailAudit, {
          audit_id: this.dataForm.id,
          status: "In Progress",
          items: this.items,
          nik: this.spgData.nik,
          name: this.spgData.name,
        })
          .then((rsp) => {
            this.isLoading = false;
          })
          .catch((err) => {
            this.isLoading = false;
            this.showNotification({
              type: "error",
              message: "Failed to Update Data",
            });
          });
      }
    },
    goBack() {
      this.isReport = false;
      this.isForm = true;
    },

    confirmSubmit() {
      fnPOST(APIPATH_CGC.updateListDetailAudit, {
        audit_id: this.dataForm.id,
        status: "Done",
        items: this.items,
        nik: this.spgData.nik,
        name: this.spgData.name,
      })
        .then((rsp) => {
          this.isLoading = false;
          this.showNotification({
            type: "success",
            message: "Data submitted successfully!",
          });
          setTimeout(() => {
            this.$router.push({ name: "CGCAuditList" });
          }, 500);
        })
        .catch((err) => {
          this.isLoading = false;
          this.showNotification({
            type: "error",
            message: "Failed to Submit Data",
          });
        });
    },

    async submitPage() {
      let isValid = true;
      this.items.forEach((item) => {
        if (isValid) {
          if (
            item.actual_qty === null ||
            item.actual_qty === "" ||
            isNaN(item.actual_qty)
          ) {
            // do nothing, valid

            isValid = false;
            this.showNotification({
              type: "error",
              message:
                "Please fill article " +
                item.article +
                " qty with valid number!",
            });

            return false;
          }
          if (
            item.actual_qty != item.qty_plan &&
            (item.remark === null || item.remark === "")
          ) {
            isValid = false;
            this.showNotification({
              type: "error",
              message: "Please fill remark " + item.article,
            });

            return false;
          }
        }
      });
      console.log(isValid);
      if (isValid) {
        this.updateData();
        this.showNotification({
          type: "success",
          message: "Data submitted successfully!",
        });
        this.isForm = false;
        this.isReport = true;
      }
    },

    doSearch() {
      this.currentPage = 1; // reset page when searching
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    checkScreen() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  mounted() {
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
  },
  created() {
    this.setData();
  },
};
</script>
<style src="../CGC.scss" lang="scss" scoped />